import moment from 'moment';
import momentLocale from 'moment/min/moment-with-locales';
import momentTZ from 'moment-timezone';
import ReactTimeAgo from 'react-time-ago';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import { TIMEZONE_ESTONIA } from './constants';
import { DATE_FORMAT_DD_MMMM_YYYY, DATE_REQUEST } from './common';

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(en);

export const roundStarts = (date, format = 'DD MMM, HH:mm') => {
  if (!date) {
    return '';
  }
  const timezone = moment.tz.guess();
  const roundTime = momentTZ.tz(date, TIMEZONE_ESTONIA).add(12, 'hours');
  return `${momentTZ.tz(roundTime, timezone).format(format)} GMT`;
};

export const resultProcess = (date, format = 'DD MMM') => {
  return date ? moment(date).add(1, 'day').format(format) : '';
};

export const remainingTime = date => {
  return (
    <span>
      <ReactTimeAgo date={date} locale="en-US" timeStyle="twitter" />
    </span>
  );
};

export const resetInvestingExpireDate = date =>
  momentLocale(date).format(DATE_FORMAT_DD_MMMM_YYYY);

export const isExpiredResetDate = date => {
  if (!date) {
    return false;
  }
  return moment(date).isBefore();
};

export const isBefore = targetDate => moment().isBefore(targetDate);

export const isAfter = targetDate => moment().isAfter(targetDate);

export function getTimeUntilRound(targetDate, hoursOffset = 0) {
  if (!targetDate) return [0, 0, 0, 0];

  const ESTONIA_TZ = 'Europe/Tallinn';
  let target;

  // ISO дата со временем
  if (targetDate.includes('T')) {
    target = momentTZ.parseZone(targetDate);
  }

  // только дата
  else {
    target = momentTZ
      .tz(targetDate, DATE_REQUEST, ESTONIA_TZ)
      .startOf('day')
      .add(hoursOffset, 'hours');
  }

  const now = momentTZ();

  const totalSeconds = Math.max(target.diff(now, 'seconds'), 0);

  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [days, hours, minutes, seconds];
}

export function getTimeLeftMessage({ targetDate, hoursOffset = 0 }, t) {
  const [days, hours] = getTimeUntilRound(targetDate, hoursOffset);

  if (days > 0) {
    return t(
      days === 1
        ? 'utils:time_left_message.days_left'
        : 'utils:time_left_message.days_left_plural',
      { count: days },
    );
  }

  if (hours > 0) {
    return t(
      hours === 1
        ? 'utils:time_left_message.hours_left'
        : 'utils:time_left_message.hours_left_plural',
      { count: hours },
    );
  }

  return '';
}

export function getTimeLeft(targetDate, t) {
  const now = new Date();
  const target = new Date(targetDate);

  if (target <= now) {
    return '';
  }

  const diffInMilliseconds = target - now;
  const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInDays > 0) {
    return t(diffInDays === 1 ? 'time_left.days' : 'time_left.days_plural', {
      count: diffInDays,
    });
  } else if (diffInHours > 0) {
    return t(diffInHours === 1 ? 'time_left.hours' : 'time_left.hours_plural', {
      count: diffInHours,
    });
  } else {
    return '';
  }
}

export const DEFAULT_THIS_YEAR_PERIOD = [
  moment().startOf('year').format(DATE_REQUEST),
  moment().format(DATE_REQUEST),
];

export function formatMonths(totalMonths, t) {
  const monthsNum = Math.max(0, Math.floor(totalMonths));
  const years = Math.floor(monthsNum / 12);
  const months = monthsNum % 12;

  // build short parts: e.g. "1y 6m" or "6m"
  const partsShort = [];
  if (years > 0) {
    partsShort.push(t('duration.short.year', { count: years }));
  }
  // always show months if years===0 OR months>0
  if (months > 0 || years === 0) {
    partsShort.push(t('duration.short.month', { count: months }));
  }
  const short_label = partsShort.join(' ');

  // build full parts: e.g. "1 year 6 months" or "6 months"
  const partsFull = [];
  if (years > 0) {
    partsFull.push(
      t(years === 1 ? 'duration.year' : 'duration.year_plural', {
        count: years,
      }),
    );
  }
  if (months > 0 || years === 0) {
    partsFull.push(
      t(months === 1 ? 'duration.month' : 'duration.month_plural', {
        count: months,
      }),
    );
  }
  const full_label = partsFull.join(' ');

  return { short_label, full_label };
}
